"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../Theme");

var _EntityHeader = require("./v2/EntityHeader");

var _EntityHeader2 = require("./v3/EntityHeader");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Component that is used as entity header that is paired with rich information about the entity.
 */


var EntityHeader = function EntityHeader(props) {
  return (0, _Theme.useThemeConfig)({
    v2: /*#__PURE__*/_react.default.createElement(_EntityHeader.EntityHeader, props),
    v3: /*#__PURE__*/_react.default.createElement(_EntityHeader2.EntityHeader, props)
  });
};

exports.EntityHeader = EntityHeader;
EntityHeader.displayName = "EntityHeader";